import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Button } from "../primitives";
import Card from "../primitives/Card";
import useTimedError from "../../hooks/useTimedError";
import { useState } from "react";
import { useTranslation } from "../../hooks/useTranslation";

export default function NewPaymentMethod({ onSubmit, setIsOpen, loading, setLoading }) {

    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useTimedError();
    const t = useTranslation();

    async function handleSubmit(event) {
        event.preventDefault();
        console.log('Handle Submit');
        setLoading(true);
        // Using PaymentElement
        const { error: submitError } = await elements.submit();
        if (submitError) {
            setError(submitError.message);
            return;
        }

        const { error, paymentMethod } = await stripe.createPaymentMethod({
            elements,
        });

        if (error) {
            setError(error.message);
            setLoading(false);
            return;
        }

        const paymentMethodId = paymentMethod.id;

        if (await onSubmit(paymentMethodId, setError)) {
            setIsOpen(false);
        }
        setLoading(false);
    }

    return (
        <Card ctype="white" className="new-payment-method-popup-card">
            <Card.Header>
                <h2 style={{ textAlign: 'center' }}>{t('Change Payment Method')}</h2>
            </Card.Header>
            <Card.Body>
                <form onSubmit={handleSubmit}>
                    <PaymentElement />
                    <Button buttonType="submit" error={error} loading={loading}>
                        {error ? error : t("Submit")}
                    </Button>
                </form>
                <Button disabled={loading} onClick={() => setIsOpen(false)}>{t('Cancel')}</Button>
            </Card.Body>
        </Card>
    );
}